import Backbone from 'backbone'
import folderGroup from './folder-group.hbs'
import template from 'scoreboard/components/scroll-container.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import _ from 'lodash'
import metadata from 'scoreboard/components/metadata'
import i18n from 'scoreboard/components/i18n'
import conductor from 'scoreboard/components/conductor'
import SendToOptions from 'scoreboard/components/send-to-options'
import emptyFolder from './empty-folder.hbs'
import sections from 'scoreboard/components/sections'

var FolderOverview = Backbone.View.extend({

	// this.model is a Backbone.Model representing a folder

	className: 'folder-overview table-hack display-layout',

	/**
	 * @param {Object} options - options for the view
	 * @param {Function} options.tabs - a function that returns the tabs template
	 * @param {Object} options.tabsContext - optional context to pass to
	 * the tabs template
	 * @returns {boolean} whether the edit tab is allowed to be displayed
	 */
	allowEdit: _.constant(true),

	initialize: function (options = {}) {
		this.options = options
		var tabContext = {
			id: this.model.id,
			section: sections.toUrl(this.model.section),
			overviewTabCode: this.options.overviewTabCode || 'common.view',
			// #57401
			// Allow custom context to be merged in case any additional
			// context is needed in the tabs template
			...options?.tabsContext
		}
		let sendToContext = {section: this.model.get('section'), type: this.model.get('type')}
		this.header = new DisplayHeader({
			heading: this.model.get('label'),
			model: this.model,
			subsection: 'overview',
			sendToOptions: _.result(this, '_sendToOptions', SendToOptions.defaultNoExport(sendToContext)),
			tabs: options.tabs && options.tabs(tabContext),
			displayHeaderButtons: this.options.displayHeaderButtons
		})
		this.header.setupOverviewInfo()
	},

	render: function() {
		this.$el.append(this.header.render().el, template())
		this.renderChildren(this.model.get('children'))
		this.secure()
		return this
	},

	/**
	 * Returns a message resource bundle key that describes what can be
	 * contained in the folder (e.g. "Report", "Dataset Views", etc).
	 */
	folderContainsKey: function() {
		return metadata[this.model.section].sectionCode
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.allowEdit())
	},

	getIcon: function() {
		return metadata[this.model.section].sectionIcon
	},

	renderChildren: function(children) {
		// If there are no items to show, display the emptyFolder view
		if (_.isEmpty(children)) {
			this.$el.addClass('empty-display')
			this.$('.display-pane-body').replaceWith(emptyFolder({
				message: i18n.get('common.emptyFolder', _.lowerCase(i18n.get(this.folderContainsKey())))
			}))
			return
		}

		this.$('.scroll-container').append(folderGroup({
			// Massage the children data in order to display it better in folder-group.hbs
			children: _.transform(children, (result, child) => {
				if (child.type == 'folder') {
					child.isFolder = true
					child.icon = 'folder'
				} else {
					child.icon = this.getIcon(child)
				}
				child.url = conductor.overviewUrl(this.model.section, child.id)
				result.push(child)
			})
		}))
	},

	remove: function () {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.header], 'remove')
	}

})

export default FolderOverview

FolderOverview.__filename__ = 'components/folder-overview.js'
